import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/hooks/use-auth";

const AppInstructions = () => {
    const { setupCompleted } = useAuth();

    const startupInstructions: string[] = [
        'Install this app by clicking "Add to Home Screen" in your browser menu.',
        'Click on "Complete Setup".',
        'Login with your ERP account. Check with your administrator for your credentials.',
        'You will be redirected to this page on successful login.',
        'A local account will be created to enable you collect data while offline.',
    ];

    const appInstructions: string[] = [
        'Use the provided forms to capture data even if you\'re offline.',
        'All data will be stored locally',
        'Data will be synced automatically when you\'re online. Make a point to sync your local data daily.',
        'You can also sync manually using the "Sync Now" button in the menu. This only works when you\'re online.'
    ];

    return (
        <Card>
            <CardHeader>
                <CardTitle>Info</CardTitle>
            </CardHeader>
            <CardContent>
                <ul className="list-decimal list-inside text-sm/6 text-left">
                    {setupCompleted ? appInstructions.map((instruction, index) => (
                        <InstructionItem key={index} instruction={instruction} />
                    )) : startupInstructions.map((instruction, index) => (
                        <InstructionItem key={index} instruction={instruction} />
                    ))}
                </ul>
            </CardContent>
        </Card>
    );
};

const InstructionItem = ({ instruction }: { instruction: string }) => {
    return (
        <li className="list-item mb-2 tracking-[-.01em] max-w-sm sm:w-full">{instruction}</li>
    )
}

export { AppInstructions };